export const MT_DROPDOWN_CLOSED = "mt-dropdown-closed";
export const ALARMS_ROW_CHECKED = "alarms-row-checked";
export const ACK_ALARM = "ack-alarm";
export const CCTV_FEED_VISIBILITY_CHANGE = "cctv-feed-visiblity-change";
export const VISIBILITY_CHANGE = "visibilitychange";
export const CCTV_VIDEO_WAITING = "cctv-video-waiting";
export const CHART_SETTINGS = "chart-settings";
export const TOOLTIP_HOVERED = "tooltip-hovered";
export const FUEL_SIDEBAR_SWITCH_TOGGLED = "fuel-sidebar-switch-toggle";
export const CCTV_TOGGLE_LARGE_VIEW = "cctv-toggle-large-view";
export const DP_JSON_DATA_RECEIVED = "dp-json-data-received";
export const DP_CATEGORIZED_DATA_RECEIVED = "dp-categorized-data-received";
